const appRoutes = {
    HOME: '/',
    GAME: '/game',
    LOGS: '/logs'
};
export default appRoutes;
